import axios from 'axios';
import API_BASE_URL from '../config/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important for session cookies
});

// Participants
export const getParticipant = (token) => api.get(`/participants/${token}`);
export const getAllParticipants = () => api.get('/participants');

// Startups
export const getStartups = () => api.get('/startups');
export const getStartup = (id) => api.get(`/startups/${id}`);

// Investments
export const createInvestment = (token, startupId, amount) => 
  api.post('/investments', { token, startupId, amount });
export const getParticipantInvestments = (token) => 
  api.get(`/investments/participant/${token}`);
export const getAllInvestments = () => api.get('/investments');

// QR Codes
export const getQRCodeForParticipant = (token) => api.get(`/qr/participant/${token}`);
export const getAllQRCodes = () => api.get('/qr/all');
export const getQRCodesByType = (type) => api.get(`/qr/type/${type}`);

// Setup
export const getSetupStatus = () => api.get('/setup/status');
export const createParticipants = (config) => api.post('/setup/participants', config);
export const updateParticipants = (config) => api.put('/setup/participants', config);
export const addStartup = (startup) => api.post('/setup/startups', startup);
export const addStartupsBulk = (startups) => api.post('/setup/startups/bulk', { startups });
export const deleteStartup = (id) => api.delete(`/setup/startups/${id}`);
export const resetDatabase = () => api.post('/setup/reset');
export const findParticipantByName = (name, type) => api.post('/setup/participants/find', { name, type });

// Auth
export const adminLogin = (password) => api.post('/auth/login', { password });
export const adminLogout = () => api.post('/auth/logout');
export const checkAuth = () => api.get('/auth/check');

export default api;
